import {
  Button,
  createStyles,
  Grid,
  lighten,
  makeStyles,
  Theme,
} from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { Mail } from "@material-ui/icons";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import clsx from "clsx";
import moment from "moment";
import React from "react";
import { CSVLink } from "react-csv";
import { IdentifierMapping } from "../../constants";
import { Test } from "../../graphql/baseTypes";
import { TEST_TYPE_TEXT } from "../../utils/testDocumentationRuleEngine";
import { transformToAddressString } from "../../utils/tests";
interface EnhancedTableToolbarProps {
  numSelected: number;
  tests: Array<Test>;
  selected: Array<string>;
  onSendMailToSelected: () => any;
}
const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
    highlight:
      theme.palette.type === "light"
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {
      flex: "1 1 100%",
    },
  })
);

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const { numSelected, selected, tests, onSendMailToSelected } = props;
  const isSelected = React.useCallback(
    (name: string) => selected.indexOf(name) !== -1,
    [selected]
  );

  const data = React.useMemo(
    () =>
      tests
        .filter(({ testId, locationId, date }) =>
          isSelected(`${locationId}#${testId}#${date}`)
        )
        .map(
          ({
            testId,
            company: { name: company },
            location: { locationId, name: location },
            date,
            result,
            patient,
            userId,
            issuedSelfTests,
            identifier,
            documentation,
          }) => {
            const {
              type,
              reason,
              paymentRequired,
              noPaymentRequiredProof,
              paymentRecived,
            } = documentation || {};
            return {
              Auftraggeber: company,
              Standort: location,
              "Standort-ID": locationId,
              Datum: moment(date).format("LLL"),
              "Test-ID": testId,
              Ergebnis: result,
              Patient: `${patient.firstname} ${patient.lastname}`,
              "Identifier Nr.": patient.insuranceNumber,
              "Identifier Typ": IdentifierMapping[identifier],

              Email: patient.email,
              Benutzer: userId,
              ...(issuedSelfTests && {
                "Ausgegebene Selbttests": issuedSelfTests,
              }),
              ...(patient.birthdate && {
                Geburstag: moment(patient.birthdate).format("DD.MM.YYYY"),
              }),
              ...((patient.address || patient.addressString) && {
                Adresse:
                  patient.addressString ||
                  transformToAddressString(patient.address) ||
                  "Keine Adresse",
              }),

              Testdurchführung:
                (type ? TEST_TYPE_TEXT[type] : null) ||
                "keine Notwendigkeit laut Testverordnung",

              Testgrund: reason || "keine Notwendigkeit laut Testverordnung",

              Zuzahlungspflicht:
                paymentRequired !== null || paymentRequired !== undefined
                  ? paymentRequired
                    ? "Ja"
                    : "Nein"
                  : "keine Notwendigkeit laut Testverordnung",

              "Nachweis für keine Zuzahlungspflicht":
                noPaymentRequiredProof ||
                "keine Notwendigkeit laut Testverordnung",

              "Zuzahlung erhalten":
                paymentRecived !== null || paymentRecived !== undefined
                  ? paymentRequired
                    ? "Ja"
                    : "Nein"
                  : "keine Notwendigkeit laut Testverordnung",
            };
          }
        ),
    [tests, isSelected]
  );
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Grid container alignItems="center" justify="space-between" spacing={2}>
        {numSelected > 0 && (
          <Grid item xs={12} md={4}>
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
            >
              {numSelected} selected
            </Typography>
          </Grid>
        )}
        {numSelected > 0 && (
          <Grid container item xs={12} md={7} justify="space-between">
            <Tooltip title="Testberichte versenden">
              <Button
                aria-label="export"
                color="primary"
                variant="outlined"
                onClick={onSendMailToSelected}
                startIcon={<Mail />}
              >
                Testbericht versenden
              </Button>
            </Tooltip>
            {/**
            * 
            *<Tooltip title="Export">
              <Button
                aria-label="export all"
                color="primary"
                variant="outlined"
                startIcon={<ImportExportIcon />}
              >
                Alles Exportieren
              </Button>
            </Tooltip>
            */}
            <Tooltip title="Export">
              <Button
                aria-label="export"
                component={CSVLink}
                data={data}
                color="primary"
                variant="outlined"
                startIcon={<ImportExportIcon />}
                filename={"mat_test_exports.csv"}
                separator={";"}
              >
                Exportieren
              </Button>
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </Toolbar>
  );
};
export default EnhancedTableToolbar;
